module.exports = __webpack_public_path__ + "img/slots-game.0974507d.jpeg";